import { render, staticRenderFns } from "./SelectPersona.vue?vue&type=template&id=7bd46709&"
import script from "./SelectPersona.vue?vue&type=script&lang=js&"
export * from "./SelectPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports